/**
 * URL embedded in the YouTube TV device-link QR.
 * Prefer a complete URI; otherwise append user_code so the phone form is prefilled.
 */
export function getCybertubeLinkQrUrl(input: {
  userCode?: string | null;
  verificationUrl?: string | null;
  verificationUrlComplete?: string | null;
} | null | undefined): string | null {
  if (!input) return null;
  const userCode = String(input.userCode || '').trim();
  if (!userCode) return null;
  const complete = String(input.verificationUrlComplete || '').trim();
  if (complete) return complete;
  const base = String(input.verificationUrl || '').trim();
  if (!base) return null;
  if (/[?&]user_code=/i.test(base)) return base;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}user_code=${encodeURIComponent(userCode)}`;
}
